import TranslationFallbackDiffField from "@/v2-backoffice-client/translation/fallback/TranslationFallbackDiffField"
import TranslationFallbackKeepCodeButton from "@/v2-backoffice-client/translation/fallback/TranslationFallbackKeepCodeButton"
import { FALLBACK_MISSING_IN_DB } from "@/v2-backoffice-client/translation/fallback/translation.fallback.utils"

// Row shape of TranslationFallbackView.
export type FallbackDiffRow = {
  code: string
  differsIn: string
  codeName: string
  dbName: string
  codeDescription: string
  dbDescription: string
}

export type TranslationFallbackDiffProps = {
  row: FallbackDiffRow
  // Fired after a resolve action lands so the owner refetches the list.
  onResolved(): void
}

// Expanded row detail of the Pending code sync table: a git-style word diff
// (code = old/−, DB = new/+, because the sync writes the DB text into the
// code) plus the resolve actions.
function TranslationFallbackDiff(props: TranslationFallbackDiffProps) {
  const { row, onResolved } = props
  const missingInDb = row.differsIn === FALLBACK_MISSING_IN_DB

  return (
    <div className="translation-diff">
      <TranslationFallbackDiffField
        label="Name"
        code={row.codeName}
        db={row.dbName}
      />
      <TranslationFallbackDiffField
        label="Description"
        code={row.codeDescription}
        db={row.dbDescription}
      />

      {/* Action anchored LEFT (before the explainer) so it stays visible
          even if the panel is wider than the viewport. */}
      <div className="translation-diff-actions">
        <TranslationFallbackKeepCodeButton
          code={row.code}
          codeName={row.codeName}
          codeDescription={row.codeDescription}
          missingInDb={missingInDb}
          onResolved={onResolved}
        />
        <p className="min-w-0 flex-1 text-xs text-muted-foreground">
          {missingInDb ? (
            <>
              The database has no English row for this text, so the sync has
              nothing to write back — this row stays here until one exists.
              Adopt the code text to create it (you can refine it afterwards
              under All texts).
            </>
          ) : (
            <>
              <strong className="text-foreground">Keep the green text:</strong>{" "}
              do nothing — the sync workflow commits the database text into the
              code on the next merge to master (or the daily run). To refine it
              first, edit the row under All texts.
            </>
          )}
        </p>
      </div>
    </div>
  )
}

export default TranslationFallbackDiff
